export var TITLES = {
  IS_AUTHORISED: 'профиль',
  NOT_IS_AUTHORISED: 'выберите<br>способ входа'
};